// src/pages/HowTradesWork.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./LegalPages.css";

const HowTradesWork = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>How Trades Work</h1>
        <p>
          NexterZone trades follow a structured workflow to improve safety, reduce fraud,
          and prevent stolen goods.
        </p>

        <div className="legal-hero-links">
          <a href="#workflow">Workflow</a>
          <a href="#no-direct-chat">Why no direct chat</a>
          <a href="#safety">Safety checks</a>
        </div>
      </div>

      <div className="legal-grid">
        <section id="workflow" className="legal-card">
          <h2>Workflow overview</h2>
          <ol className="legal-ol">
            <li>Browse listings and make an offer</li>
            <li>Seller accepts an offer</li>
            <li>Verification and risk checks (when applicable)</li>
            <li>Pickup scheduling and collection</li>
            <li>Inspection / condition confirmation</li>
            <li>Delivery scheduling and completion</li>
          </ol>
          <p className="legal-muted">
            The exact steps may vary depending on category, risk signals, and operational requirements.
          </p>
        </section>

        <section id="no-direct-chat" className="legal-card">
          <h2>Why there is no direct chat</h2>
          <p>
            We limit direct contact exchange to reduce scams, intimidation, pressure selling,
            and off-platform deals. Official NexterZone updates guide the trade safely from
            start to finish.
          </p>
          <p className="legal-muted">
            This design choice prioritises community safety and accountability over speed.
          </p>
        </section>

        <section id="safety" className="legal-card">
          <h2>Safety and anti-theft controls</h2>
          <ul className="legal-ol">
            <li>Risk screening for suspicious patterns</li>
            <li>Verification evidence requests (photos/videos) where needed</li>
            <li>Inspection checkpoints (pickup / hub / delivery)</li>
            <li>Trades may be paused, cancelled, or escalated for review</li>
          </ul>
          <p className="legal-muted">
            If you suspect a listing involves stolen goods, do not proceed — report it through NexterZone.
          </p>
        </section>
      </div>

      <section className="legal-callout">
        <h3>Need more?</h3>
        <p>
          Read our <Link to="/trust-safety">Trust &amp; Safety</Link> page for the bigger picture,
          or visit the <Link to="/help">Help Center</Link>.
        </p>
      </section>
    </div>
  );
};

export default HowTradesWork;
